import React, { useEffect, useState, useCallback } from "react";
import { Button, Typography, Card, List, Empty, message } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { FileAddOutlined, EditOutlined } from '@ant-design/icons';
import InspectionHistory from "../components/inspections/InspectionHistory";
import { getAllInspectionDrafts, deleteInspectionDraft, getInspectionDraft } from "../utils/inspectionCacheUtils";
import { formatDate } from "../utils/dateUtils";

const { Title } = Typography;

const Inspections = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [localDrafts, setLocalDrafts] = useState([]);
  const [isOffline, setIsOffline] = useState(false);

  const loadLocalDrafts = useCallback(async () => {
    try {
      const online = typeof navigator === 'undefined' ? true : navigator.onLine;
      setIsOffline(!online);
      const drafts = await getAllInspectionDrafts();
      // When offline, include resp-* cached drafts so server drafts are accessible.
      // When online, keep them hidden to reduce duplicates in the UI.
      const nextLocalDrafts = online
        ? (drafts || []).filter(d => !d.cacheKey?.startsWith('resp-') && !d.draftId?.startsWith('resp-'))
        : (drafts || []);
      setLocalDrafts(nextLocalDrafts);
    } catch (e) {
      console.error('Failed to load local inspection drafts:', e);
    }
  }, []);

  useEffect(() => {
    loadLocalDrafts();
  }, [loadLocalDrafts, location.key]);

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: "flex", gap: 12 }}>

        <div
                  className="action-card"
                  onClick={() => navigate('/inspections/newInspections')}
                  style={{
                    backgroundColor: '#f5f5f5',
                    color: '#333',
                    borderRadius: '8px',
                    height: '100px',
                    display: 'flex',
                    flex: '1',
                    minWidth: '120px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                  }}
                >
                  <FileAddOutlined style={{ fontSize: '24px', marginBottom: '4px' }} />
                  <div style={{ textAlign: 'center', fontWeight: '500', fontSize: '12px' }}>New</div>
                </div>

        <div
                  className="action-card"
                  onClick={() => navigate('/inspections/draftInspections')}
                  style={{
                    backgroundColor: '#f5f5f5',
                    color: '#333',
                    borderRadius: '8px',
                    height: '100px',
                    display: 'flex',
                    flex: '1',
                    minWidth: '120px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                  }}
                >
                  <EditOutlined style={{ fontSize: '24px', marginBottom: '4px' }} />
                  <div style={{ textAlign: 'center', fontWeight: '500', fontSize: '12px' }}>Drafts</div>
                </div>
      </div>
      <br/>
      <Card title="Inspection History">
        <InspectionHistory />
      </Card>
    </div>
  );
};

export default Inspections;
